export default __webpack_public_path__ + "static/media/general_assembly.8d5519a8.png";